import {AfterViewInit, Directive, inject, OnDestroy} from '@angular/core';
import {distinctUntilChanged, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import { ComposableRouteService } from './composable-route.service';

@Directive()
// @Directive() serve per permettere l'estensione anche da componenti
export abstract class AbstractComposableRouterComponent implements AfterViewInit, OnDestroy {

  protected destroy$ = new Subject<void>();
  protected composableRouteService = inject(ComposableRouteService);

  /**
   * Ogni componente concreto deve restituire la chiave del tab (es. 'RELEASE_TABS')
   */
  protected abstract getTabKey(): string;

  /**
   * Ogni componente concreto deve gestire il cambio tab
   */
  protected abstract changedTab(tab: string): void;


  /**
   * Chiamato una sola volta, dopo che la view del componente e le sue view figlie sono inizializzate.
   */
  ngAfterViewInit(): void {
    const tabKey = this.getTabKey();

    this.composableRouteService.onChangeRoute(tabKey)
      .pipe(
        takeUntil(this.destroy$),
        distinctUntilChanged()
      )
      .subscribe((value: string) => {
        this.changedTab(value);
      });
  }

  ngOnDestroy(): void {
    // Trovato solo in alcuni componenti
    this.composableRouteService.removeValue(this.getTabKey());

    this.destroy$.next();
    this.destroy$.complete();
  }
}
